import Vue from 'vue';
import creditNoteProductTransformer from './../../transformers/creditNoteProduct';

const success = (data, id, resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(creditNoteProductTransformer.fetch(errors));
};

export default (id, creditNoteProduct, creditNoteProductId) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .put(`/credit_notes/${id}/products/${creditNoteProductId}`, creditNoteProductTransformer.send(creditNoteProduct))
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNoteProduct/update.js